import React from 'react';
import { Box, Typography } from '@mui/material';
import { Info } from '@mui/icons-material';

export const ORDER_DISCLAIMER_HEIGHT = 72;

const OrderDisclaimer = ({ bgColor, fontColor }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxSizing: 'border-box',
        minHeight: ORDER_DISCLAIMER_HEIGHT,
        padding: '8px 12px',
        backgroundColor: bgColor ?? '#FFF8E1',
        border: '1px solid #F5C36B',
        borderRadius: '8px',
      }}
    >
      <Info sx={{ fontSize: 20, color: '#B7791F', flexShrink: 0 }} />
      <Typography
        sx={{
          color: `${fontColor ?? '#5C4A1E'} !important`,
          fontFamily: 'Inter !important',
          fontSize: '12px !important',
          lineHeight: '16px !important',
        }}
      >
        Orders placed from different devices are sent to the kitchen/bar
        separately and may be prepared and served at different times, even
        when sharing a table.
      </Typography>
    </Box>
  );
};

export default OrderDisclaimer;
